import React from 'react';
import { renderFields } from '../../util/RenderUtil';

/** renders a field group with 50 50 split */
const FieldGroup5050 = props => {
  return (
    <div className="field-group-5050">
      {renderFields(props, (renderedChild, index) => (
        <div key={index} className="field-group-5050-col">
          {renderedChild}
        </div>
      ))}
    </div>
  );
};

export default FieldGroup5050;
